let initialized = false;
let measurementId = "";

export interface AnalyticsUser {
    userId?: string;
    company?: string;
}

export interface AnalyticsProject {
    projectId?: string;
    projectName?: string;
}

const initialize = function(id: string) {
    if (initialized) {
        return;
    }

    initialized = true;
    measurementId = id;

    window.dataLayer = window.dataLayer || [];

    window.gtag = function() {
        // gtag.js consumes native Arguments objects, not arrays of arguments.
        window.dataLayer.push(arguments.valueOf());
    };

    window.gtag("js", new Date());

    window.gtag("config", id, {
        send_page_view: false
    });

    const script = document.createElement("script");

    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;

    document.head.appendChild(script);
}

const setUser = function(user?: AnalyticsUser) {
    if (!initialized || !window.gtag) {
        return;
    }

    window.gtag("config", measurementId, {
        user_id: user?.userId ?? null,
        send_page_view: false
    });

    window.gtag("set", "user_properties", {
        company: user?.company ?? null
    });
}

const trackPage = function(
    path: string,
    project?: AnalyticsProject
) {
    if (!initialized || !window.gtag) {
        return;
    }

    window.gtag("event", "page_view", {
        send_to: measurementId,
        page_path: path,
        page_location: new URL(path, window.location.origin).href,
        page_title: document.title,
        project_id: project?.projectId,
        project_name: project?.projectName
    });
}

const trackEvent = function(
    eventName: string,
    parameters?: Record<string, unknown>,
    project?: AnalyticsProject
) {
    if (!initialized || !window.gtag) {
        return;
    }

    window.gtag("event", eventName, {
        ...parameters,
        send_to: measurementId,
        project_id: project?.projectId,
        project_name: project?.projectName
    });
}

export { initialize, setUser, trackPage, trackEvent }
